export function belgianIdValidate(id: string, millenial?: boolean) {
  id = id.replace(".", "").replace("-", "");
  if (id.length < 11) return false;

  const numberToValidate = (millenial ? 2000000000 : 0) + parseInt(id.slice(0, 9));
  const validator = parseInt(id.slice(9));
  return 97 - (numberToValidate % 97) === validator;
}
